module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_5012.5f49c6b6.png";